import ApplicationLayout from './ApplicationLayout';

export default ApplicationLayout;
